export enum LivelloIntegrazioneEnum {
  LV1 = 1,
  LV2 = 2,
  LV2_BACK_OFFICE = 3,
  M3 = 5,
  M3P = 6
}
